import product1 from "./assets/products/1.png";
import product2 from "./assets/products/2.png";
import product3 from "./assets/products/3.png";
import product4 from "./assets/products/4.png";
import product5 from "./assets/products/5.png";
import product6 from "./assets/products/6.webp";
import product7 from "./assets/products/7.webp";
import product8 from "./assets/products/8.webp";

export const PRODUCTS = [
  {
    id: 1,
    productName: "Winter Jacket",
    price: 99.00,
    productImage: product1,
  },
  {
    id: 2,
    productName: "Black T-shirt",
    price: 11.00,
    productImage: product2,
  },
  {
    id: 3,
    productName: "Zipped Hood",
    price: 39.00,
    productImage: product3,
  },
  {
    id: 4,
    productName: "Sweater",
    price: 22.00,
    productImage: product4,
  },
  {
    id: 5,
    productName: "Stripped Sweater",
    price: 12.99,
    productImage: product5,
  },
  {
    id: 6,
    productName: "Round neck Sweater",
    price: 48.00,
    productImage: product6,
  },
  {
    id: 7,
    productName: "Hood",
    price: 20.00,
    productImage: product7,
  },
  {
    id: 8,
    productName: "Yellow T-shirt",
    price: 10.00,
    productImage: product8,
  },
];
